<div>
  <Heading bold sm border-bottom="3" mt="md" pb="xs">
    Columnas
  </Heading>

  <Panel my="xs">
    {#each columns as col}
      <Tag 
        on:delete={() => deleteColumn(col.name)}
        label={col.label}
        />
    {/each}
  </Panel>

  <select 
    class="column-selector" 
    bind:value={selected} 
    nochange={columnSelected}>
    <option value="-1">Agregar otra columna ...</option>
    {#each meta.sections as section}
      <optgroup label={section.label}>
        {#each section.controls as control}
          <option value={control.property}>{control.label}</option>
        {/each}
      </optgroup>
    {/each}
  </select>

</div>

<script>
	import { tick } from 'svelte';
  import { RecordDef, is } from '@/models'
  import { Heading, Panel } from 'svelte-stylo'
  import { Tag } from '@/components'

  export let meta = {};
  export let columns = [];

  let selected = null;

  $: if (selected !== null) {
    columnSelected();
  }

  function columnSelected() {
    if (! selected) return;
    columns = columns.concat([{
      name: selected,
      label: meta.dictionary[selected].label
    }]);
    selected = "-1";
  }

  function deleteColumn(name) {
    columns = columns.filter((t) => {
      return (t.name !== name)
    });
  }

</script>

<style>

  .columns-list {
    font-size: 14px;
    line-height: 20px;
    margin-top: 0.5rem;
  }

  .columns-list-title {
    margin-top: 12px;
    font-size: 14px;
    font-weight: normal;
    color: #889;
  }

  .column-item {
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 14px;
    margin-right: 2px;
    margin-bottom: 4px;
    padding: 1px 0;
  }

  .column-item-label {
    font-size: 14px;
    padding: 4px 0px 4px 12px;;
    margin: 0;
    display: inline-block;
    color: #2b2b6f;
  }

  .column-item-delete-btn {
    background-color: transparent;
    font-size: 14px;
    border: none;
    margin: 0 4px;
    padding: 0 8px 0 8px;
    display: inline-block;
    cursor: pointer;
    color: #9d9d9d;
  }

  .column-selector {
    border: none;
    background-color: #eee;
    border-radius: 4px;
    padding: 0.25rem 0.5rem;    
    font-size: 14px;
    color: #ab3a3a;
    margin-top: 2px;
    width: 22ch;
  }

</style>
